module.exports = __webpack_public_path__ + "static/img/land-img1.adeb9ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/land-img1.jpg
// module id = lB4H
// module chunks = 1